import customAxios from "../../customAxios";
import {GET_OR_EXIST_PARENT} from "../../routes";

const getOrExistParent = async (phoneNumber: string): Promise<any> => {
  try {
    return (await customAxios.get(`${GET_OR_EXIST_PARENT}?phoneNumber=${phoneNumber}`)).data;
  } catch (error: any) {
    console.log({GET_OR_EXIST_PARENT: error});
  }
};

export default getOrExistParent;
